/* eslint-disable @typescript-eslint/no-explicit-any */
import { METADATA_KEY, metadataDecorator, MetadataTargetConstructor } from '@/decorators/metadata';

export interface FactoryService<R> {
  factoryCreate: (...args: any[]) => R;
}

export type FactoryServiceConstructor<T> = MetadataTargetConstructor<FactoryService<T>>;

type InferFactoryServiceReturnType<T = any> = T extends FactoryServiceConstructor<infer TReturn>
  ? TReturn :
  any;

export function factory<
  TServiceIdentifier extends FactoryServiceConstructor<any>,
  TReturn = InferFactoryServiceReturnType<TServiceIdentifier>,
>(
  serviceIdentifier: TServiceIdentifier,
  force?: boolean,
) {
  // eslint-disable-next-line func-names
  return function <
    TTarget extends FactoryServiceConstructor<TReturn>,
  > (target: TTarget) {
    const syntax = metadataDecorator<TReturn, TTarget>(
      METADATA_KEY.FACTORY,
      serviceIdentifier,
      target,
      force,
    );

    syntax.constraint = (bind, bindTarget) => bind(serviceIdentifier)
      .toFactory<TReturn>(() => (...args) => bindTarget.factoryCreate(...args));
  };
}
